import React, {ReactElement} from 'react';
import {useAppSelector, useAppDispatch, useStoreSlug} from '../../hooks';
import {useUpdateStoreMutation} from '../../api/storesApi';
import {removePendingDetail} from '../../slices/storesSlice';
import {
  PendingStoreDetails,
  StoreImageType,
  imageTypeToUrl
} from '../../models/storeDetails';
import trashCan from '../../assets/icons/trashcan.svg';
import './index.scss';

type ClearExistingImagePropsType = {
  imageType: StoreImageType;
};

const ClearExistingImage: React.FC<ClearExistingImagePropsType> = ({
  imageType
}: ClearExistingImagePropsType): ReactElement => {
  const storeDetails = useAppSelector(state => state.stores.storeDetails);
  const pendingDetails = useAppSelector(state => state.stores.pendingDetails);
  const dispatch = useAppDispatch();
  const localImages = useAppSelector(state => state.stores.localImages);
  const urlSlug = useStoreSlug();
  const [triggerUseUpdateStoreMutation] = useUpdateStoreMutation();

  const onButtonClick = () => {
    const storeParams: PendingStoreDetails = {
      [imageType]: null
    };

    if (imageType === 'heroImage') {
      if (storeDetails.heroLogoVisibility === 'hero_background') {
        storeParams.heroLogoVisibility = 'hero_logo';
      }
      if (pendingDetails.heroLogoVisibility === 'hero_background') {
        dispatch(removePendingDetail('heroLogoVisibility'));
      }
    }

    if (
      imageType === 'heroImage' &&
      storeDetails.heroLogoVisibility === 'hero_background'
    ) {
      storeParams.heroLogoVisibility = 'hero_logo';
    }

    triggerUseUpdateStoreMutation({details: storeParams, slug: urlSlug});
  };

  return (
    !localImages[imageType] &&
    storeDetails &&
    !!storeDetails[imageTypeToUrl[imageType]] && (
      <>
        <button onClick={onButtonClick} type="button">
          <img className="trashCan" src={trashCan} alt="Trash Can" />
        </button>
      </>
    )
  );
};

export default ClearExistingImage;
